/* eslint import/extensions: 'off' */
/* eslint import/no-unresolved: 'off' */

/* Libs */
import React, { useEffect, useState } from 'react';
import {
	Redirect, NavLink, Route, Switch, useHistory, useLocation
} from 'react-router-dom';
import { fromUnixTime } from 'date-fns';

import { formatDistanceToNow } from 'Helpers/dates';

/* Stores */
import useOrdersStore from 'Stores/Orders';

/* Components */
import Header from 'Components/Header';
import Icon from 'Components/Icon';

/* pages */
import ListOrders from './components/ListOrders.js';
import SearchOrder from './components/SearchOrder.js';

import './style.scss';

const Orders = () => {
	const syncOrders = useOrdersStore(store => store.syncOrders);
	const fetchingSyncOrders = useOrdersStore(store => store.fetchingSyncOrders);
	const getOrdersCount = useOrdersStore(store => store.getOrdersCount);
	const lastSync = useOrdersStore(store => store.lastSync);
	const getLastSync = useOrdersStore(store => store.getLastSync);
	const ordersCount = useOrdersStore(store => store.ordersCount);
	const [loadingCount, setLoadingCount] = useState(true);
	const location = useLocation();
	const history = useHistory();

	const [displaySearch, setDisplaySearch] = useState(location.pathname.includes('/orders/search') || false);
	const labelSync = lastSync ? `Dernière synchro: ${formatDistanceToNow(fromUnixTime(lastSync))}` : '';

	const ordersActions = [
		{
			icon: {
				isHM: true, name: 'utilitary_sync', label: labelSync, position: 'left'
			},
			callback: syncOrders
		},
		{
			icon: {
				isHM: true, name: 'utilitary_search', label: 'Rechercher une commande', position: 'left'
			},
			callback: () => {
				history.push('/orders/search');
				setDisplaySearch(true);
			}
		}
	];
	const iconBack = {
		isHM: true,
		name: 'utilitary_back'
	};

	useEffect(() => {
		getOrdersCount();
		getLastSync();
	}, []);

	useEffect(() => {
		setLoadingCount(false);
	}, [ordersCount]);

	if (loadingCount) {
		return <p>Récupération des commandes ...</p>;
	}

	return (
		<div className="orders-page">
			{ fetchingSyncOrders && (
				<div className="overlay-sync">
					Synchronisation en cours ...
					<div className="animation-sync"><Icon isHM name="utilitary_sync" /></div>
				</div>
			)}

			<Header
				title="Gestion des commandes"
				actions={ordersActions}
			>
				{ !displaySearch && (
					<div className="App-Navigation">
						{/* <NavLink to="/orders" exact>Tableau de bord</NavLink> */}
						<NavLink to="/orders/new">Nouveaux <b>({ordersCount.new})</b></NavLink>
						<NavLink to="/orders/pending">À Préparer <b>({ordersCount.pending})</b></NavLink>
						<NavLink to="/orders/sending">À Envoyer <b>({ordersCount.sending})</b></NavLink>
						<NavLink to="/orders/sent">Terminés <b>({ordersCount.sent})</b></NavLink>
					</div>
				)}
				{ displaySearch && (
					<div
						className="icon-back"
						role="button"
						tabIndex={0}
						onClick={() => {
							setDisplaySearch(false);
							history.push('/orders');
						}}
					>
						<Icon {...iconBack} /> Retourner aux commandes
					</div>
				)}
			</Header>

			<div className="App-Content">
				<Switch>
					<Route path="/orders" exact>
						<Redirect to="/orders/new" />
					</Route>
					<Route path="/orders/search" exact>
						<SearchOrder />
					</Route>
					<Route path="/orders/new">
						<ListOrders sort="new" />
					</Route>
					<Route path="/orders/pending">
						<ListOrders sort="pending" />
					</Route>
					<Route path="/orders/sending">
						<ListOrders sort="sending" />
					</Route>
					<Route path="/orders/sent">
						<ListOrders sort="sent" />
					</Route>
				</Switch>
			</div>
		</div>
	);
};

export default Orders;
